export const ELIGIBILITY_CODES = {
  tooSoon: 'tooSoon',
};
export const StartPageActions = {
  CREATE_CLAIM: 'create-claim',
  VIEW: 'view',
};
export const SHIPPING_CLAIM = 'shippingClaim';
export const WARRANTY_CLAIM = 'warrantyClaim';
export const RETURN = 'return';
export const PROCESS_OPTIONS = [SHIPPING_CLAIM, WARRANTY_CLAIM, RETURN];
